"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailPriceFormatArgs = void 0;
const config_type_1 = require("../config-type");
const price_format_args_1 = require("./price-format-args");
class RetailPriceFormatArgs extends price_format_args_1.PriceFormatArgs {
    constructor(_locale, _currency, _cxFamily, _cxId, _cxProgram, _priceFormatType) {
        super(_locale, _currency, _cxFamily, _cxId, _cxProgram, _priceFormatType);
    }
    getConfigType() {
        return config_type_1.ConfigType.RETAIL_PRICE_FORMAT;
    }
    getArgsMap() {
        return new Map([
            ['locale', this._locale],
            ['currency', this._currency],
            ['cx_family', RetailPriceFormatArgs.RETAIL_CX_FAMILY],
            ['cx_id', this._cxId],
            ['cx_program', this._cxProgram],
            ['price_format_type', this._priceFormatType]
        ]);
    }
}
exports.RetailPriceFormatArgs = RetailPriceFormatArgs;
RetailPriceFormatArgs.RETAIL_CX_FAMILY = 'retail';
//# sourceMappingURL=retail-price-format-args.js.map